import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { createGraphQLRequest } from "../../../../api/utils/httpRequest"
import type { AuditData, CategoryModifierGroupResponse, ResponseData } from "../../../../graphql/types"

export const fetchModifierGroups = (headers: Record<string, any>): Promise<Maybe<CategoryModifierGroupResponse>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query itemsCategoriesModifierGroups {
                    itemsCategoriesModifierGroups {
                        data {
                            id
                            name
                            displayName
                            price
                            isActive
                            isActivePOS
                            isActiveMIB
                            isActiveKiosk
                            displayType
                            isExclusion
                            max
                            min
                            free
                            groupPrice
                            modifiers {
                                id
                                categoryId
                                name
                                price
                                supplement
                            }
                            addedToItems {
                                id
                                name
                                icon
                                color
                            }
                        }
                        overrides {
                            locationId
                            data {
                                id
                                price
                                isActive
                                max
                                min
                                free
                                groupPrice
                                modifiers {
                                    id
                                    price
                                    supplement
                                }
                            }
                        }
                    }
                }
            `,
            operationName: "itemsCategoriesModifierGroups",
        },
    }).then(response => {
        if (response && response.data && response.data.itemsCategoriesModifierGroups) {
            return response.data.itemsCategoriesModifierGroups
        }

        return null
    })

// Todo: switch also ModifierGroup deleting to request events (we did that for adding and updating)
export const modifierGroupDelete = (
    headers: Record<string, any>,
    id: string,
    auditData: AuditData
): Promise<Maybe<ResponseData>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation modifierGroupDelete($id: String!, $auditData: AuditData) {
                    modifierGroupDelete(id: $id, auditData: $auditData) {
                      success
                    }
                }
            `,
            operationName: "modifierGroupDelete",
            variables: {
                id: id,
                auditData: auditData,
            },
        },
    }).then(response => {
        return response.modifierGroupDelete
    })
